import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../store/store';
import get from 'lodash/get';
import { fetchServiceCode } from '../store/slices/serviceCodeSlice';

export const useServiceCode = () => {
  const dispatch = useDispatch();
  const { findAll } = useSelector((state: AppState) => state.serviceCode);

  useEffect(() => {
    dispatch(fetchServiceCode({ limit: 1000 }));
  }, []);

  const items = get(findAll, 'payload.items', []);

  const findByUuids = (ids: string[]) => {
    return items.filter((item) => ids.includes(item.uuid));
  };

  return {
    items,
    itemsLoading: get(findAll, 'loading', false),
    findByUuids
  };
};
